import Enum from './Enum';

export default function createEnum(...types) {
    return new Enum(...types);
}
